import { render, staticRenderFns } from "./Aprovacao.vue?vue&type=template&id=4a67bc25&"
import script from "./Aprovacao.vue?vue&type=script&lang=js&"
export * from "./Aprovacao.vue?vue&type=script&lang=js&"
import style0 from "./Aprovacao.vue?vue&type=style&index=0&id=4a67bc25&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports